import React, { useState, useEffect, useMemo } from 'react';
import { getAllPosts, CATEGORIES } from '../lib/dataService';
import NewsCard from '../components/NewsCard';
import { Search } from 'lucide-react';
import { Input } from '../components/ui/input';

const PER_PAGE = 12;

export default function NewsPage() {
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState('all');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  useEffect(() => {
    getAllPosts().then(setPosts);
  }, []);

  const filtered = useMemo(() => {
    let list = posts;
    if (category !== 'all') {
      list = list.filter((p) => p.category_slugs && p.category_slugs.includes(category));
    }
    if (search.trim()) {
      const q = search.toLowerCase();
      list = list.filter((p) => p.title.toLowerCase().includes(q) || p.excerpt.toLowerCase().includes(q));
    }
    return list;
  }, [posts, category, search]);

  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const pagePosts = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  useEffect(() => { setPage(1); }, [category, search]);

  const usedCats = useMemo(() => {
    const set = new Set();
    posts.forEach((p) => (p.category_slugs || []).forEach((c) => set.add(c)));
    return CATEGORIES.filter((c) => set.has(c.slug));
  }, [posts]);

  return (
    <div className="news-page">
      <div className="page-hero">
        <div className="container">
          <span className="page-hero-label">CIBA Newsroom</span>
          <h1>News</h1>
          <p>{posts.length} stories from Cayman basketball — leagues, national teams and community.</p>
        </div>
      </div>

      <div className="container section">
        <div className="news-toolbar">
          <div className="cat-filters">
            <button className={`cat-chip ${category === 'all' ? 'active' : ''}`} onClick={() => setCategory('all')}>All</button>
            {usedCats.map((c) => (
              <button key={c.slug} className={`cat-chip ${category === c.slug ? 'active' : ''}`} onClick={() => setCategory(c.slug)}>
                {c.name}
              </button>
            ))}
          </div>
          <div className="news-search">
            <Search size={16} className="news-search-icon" />
            <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search news..." className="news-search-input" />
          </div>
        </div>

        {pagePosts.length === 0 ? (
          <p className="empty-state">No stories found. Try a different filter or search term.</p>
        ) : (
          <div className="news-grid">
            {pagePosts.map((post) => (
              <NewsCard key={post.slug} post={post} />
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="pagination">
            <button disabled={page === 1} onClick={() => { setPage(page - 1); window.scrollTo(0, 0); }}>Previous</button>
            <span>Page {page} of {totalPages}</span>
            <button disabled={page === totalPages} onClick={() => { setPage(page + 1); window.scrollTo(0, 0); }}>Next</button>
          </div>
        )}
      </div>
    </div>
  );
}
